<template>
	<v-layout row class="ma-3">
		<v-row v-on:click="onClick()" style="border-bottom:1px solid #ccc">
			<v-col cols="5" class="headers" align-self="center">
				Nombre
			</v-col>
			<v-col
				v-on:click.stop="openDetailsPage()"
				cols="7"
				class="table-row name"
				align-self="center"
			>
				{{ processed.projectName }}
			</v-col>
			<v-col cols="5" class="headers" align-self="center">
				Descripción
			</v-col>
			<v-col cols="7" class="table-row" align-self="center">
				<div class="ma-0 pa-0 description">
					<div class="pt-1">
						<span v-if="processed.description.length < 100">
							{{ processed.description }}
						</span>
						<span v-else>
							{{ processed.description.substring(0, 97) + "..." }}
						</span>
					</div>
					<div class="font-weight-medium" align-self="center">
						{{
							$tc("camerasProcessed", [processed.cameras], {
								cams: processed.cameras,
							})
						}}
					</div>
				</div>
			</v-col>
			<v-col cols="5" class="headers" align-self="center">
				Grabaciones
			</v-col>
			<v-col cols="7" class="table-row" align-self="center">
				{{ processed.recordings }}
			</v-col>
			<v-col cols="5" class="headers" align-self="center">
				Expira en
			</v-col>
			<v-col cols="7" class="table-row table-row-days " align-self="center">
				<ExpirationCounter :date="processed.expirationDate" />
			</v-col>
			<v-col cols="5" class="headers" align-self="center">
				Estado
			</v-col>
			<v-col cols="7" align-self="center" class="table-row">
				<status-box
					:status="processed.status"
					:projectId="processed.id"
					:isProgress="true"
					:progressValue="processed.progress"
				/>
			</v-col>
			<v-col cols="5" class="headers" align-self="center"> </v-col>
			<!--
    <v-col cols="7" class="table-row" align-self="center"> 
      <icon class="icon-size" v-if="processed.download" @clicked="openDetailsPage" icon="mdi-arrow-down-circle-outline" :name="$t('download')"/>
      <icon class="icon-size" v-if="processed.auditActions" @clicked="auditResult(true)"
      icon="mdi-check-circle-outline" :name="$t('audit.pre-approve')" :disableIcon="(project.status==='Approved')"
      />
      <icon class="icon-size" v-if="processed.auditActions" @clicked="auditResult(false)" icon="mdi-close-circle-outline" :name="$t('audit.deny')"  :disableIcon="(project.status==='Denied')"/>
    </v-col>-->
		</v-row>
	</v-layout>
</template>

<script>
import ExpirationCounter from "./ExpirationCounter";
//import Icon from '@/components/base/Icon'
import PermissionMixin from "@/mixins/PermissionMixin";
import DateParseMixin from "@/mixins/DateParseMixin";

export default {
	mixins: [PermissionMixin, DateParseMixin],
	props: {
		icon: String,
		project: Object,
	},
	components: {
		ExpirationCounter,
		//Icon
	},
	data() {
		return {};
	},
	mounted() {},
	computed: {
		processed: {
			get() {
				return {
					projectName: this.project.projectName,
					description: this.project.description,
					startedBy: this.project.startedBy,
					cameras: this.cameraCount,
					hours: this.totalhours(),
					recordings: this.recordings,
					creationDate: this.project.creationDate,
					expirationDate: this.project.expirationDate,
					status: this.project.status,
					size: this.size,
					downloaders: this.project.downloaders,
					download:
						(this.userCanAudit &&
							(this.project.status === "Finished" ||
								this.project.status === "Approved" ||
								this.project.status === "Denied")) ||
						this.project.status === "Approved",
					auditActions:
						this.userCanAudit &&
						(this.project.status === "Finished" ||
							this.project.status === "Approved" ||
							this.project.status === "Denied"),
					extractions: this.project.extractions,
					statusLogs: this.project.statusLogs,
					id: this.project.id,
					progress: this.project.progress,
				};
			},
		},
		recordings: {
			get() {
				var min, max;
				min = new Date(
					this.project.extractions[0].downloadTimeRange.split(/( - )/)[0] +
						" UTC"
				);
				max = new Date(
					this.project.extractions[0].downloadTimeRange.split(/( - )/)[2] +
						" UTC"
				);
				this.project.extractions.forEach((extraction) => {
					var from, to;
					from = new Date(
						extraction.downloadTimeRange.split(/( - )/)[0] + " UTC"
					);
					to = new Date(
						extraction.downloadTimeRange.split(/( - )/)[2] + " UTC"
					);
					if (from < min) min = from;
					if (to > max) max = to;
				});

				return (
					"Grabaciones desde " +
					min.toLocaleDateString() +
					" hasta " +
					max.toLocaleDateString()
				);
			},
		},
		cameraCount: {
			get() {
				var cameraFound = [];
				this.project.extractions.forEach((extraction) => {
					if (!cameraFound.includes(extraction.cameraName))
						cameraFound.push(extraction.cameraName);
				});
				return cameraFound.length;
			},
		},
		size: {
			get() {
				var a = 0;
				if (
					this.project.status === "Finished" ||
					this.project.status === "Approved" ||
					this.project.status === "Denied"
				) {
					this.project.extractions.forEach((extr) => {
						a += extr.totalSize;
					});
					return a;
				}
				return a;
			},
		},
	},
	methods: {
		openDetailsPage() {
			this.$store.commit("setProjectForDetails", this.project.id);
			this.$router.push("/details");
		},
		auditResult(value) {
			this.$store.dispatch("setOnDialog", {
				audit: true,
				result: value,
				project: this.project,
			});
		},
		onClick() {
			this.$store.dispatch("triggerDetailsDrawer", {
				displayDrawer: true,
				detailedProject: this.processed,
				projectRaw: this.project,
			});
			this.$emit("drawerKey");
		},
		totalhours() {
			var res = 0;
			if (this.project.extractions.lenght < 1) return res;
			this.project.extractions.forEach((extr) => {
				var dts = new Date(extr.downloadTimeRange.split(" - ")[0]);
				var dte = new Date(extr.downloadTimeRange.split(" - ")[1]);
				res = res + (dte.getTime() - dts.getTime()) / 1000 / 60 / 60;
			});
			return res;
		},
	},
};
</script>
<style scoped>
.name {
	color: #0d5ae5;
	cursor: pointer;
}
.description {
	color: #91919c;
}
.icon-hover:hover {
	color: #2196f3 !important;
	cursor: pointer;
}
.headers {
	visibility: hidden;
}
.table-row {
	font-size: 14px !important;
	text-align: right !important;
}
.table-row-days {
	font-size: 14px !important;
}
.table-header {
	color: #666;
	font-weight: bold;
}
@media (max-width: 960px) {
	.headers {
		visibility: visible;
		font-size: 14px;
		font-weight: bold;
	}
	.table-row {
		text-align: right;
	}
	.table-row-days {
		text-align: right;
	}
}
@media (max-width: 585px) {
	.description {
		width: 270px !important;
	}
}
@media (max-width: 560px) {
	.description {
		width: 250px !important;
	}
}
@media (max-width: 526px) {
	.description {
		width: 240px !important;
	}
}
@media (max-width: 500px) {
	.description {
		width: 230px !important;
	}
}
@media (max-width: 480px) {
	.description {
		width: 220px !important;
	}
}
@media (max-width: 475px) {
	.description {
		width: 210px !important;
	}
}
@media (max-width: 455px) {
	.description {
		width: 200px !important;
	}
	.table-row {
		font-size: 13px !important;
	}
	.table-row-days {
		font-size: 13px !important;
	}
	.headers {
		font-size: 13px;
	}
}
@media (max-width: 435px) {
	.description {
		width: 190px !important;
	}
}
@media (max-width: 420px) {
	.description {
		width: 180px !important;
	}
}
@media (max-width: 405px) {
	.description {
		width: 170px !important;
	}
}
@media (max-width: 380px) {
	.description {
		width: 160px !important;
	}
}
@media (max-width: 365px) {
	.description {
		width: 150px !important;
	}
	.table-row {
		font-size: 11px !important;
	}
	.table-row-days {
		font-size: 11px !important;
	}
	.headers {
		font-size: 11px;
	}
}
@media (max-width: 350px) {
	.description {
		width: 140px !important;
	}
}
@media (max-width: 330px) {
	.description {
		width: 130px !important;
	}
	.row {
		max-width: 99% !important;
	}
	.layout {
		margin: 0 !important;
	}
}
@media (max-width: 310px) {
	.description {
		width: 120px !important;
	}
}
@media (max-width: 270px) {
	.description {
		width: 110px !important;
	}
}
</style>
